const resourceCard = function () {
  $('.gated-card.card-item').on('click', function () {
    const dataLocalStorageKey = $(this).attr('data-local-storage-key') || '';
    const dataSuccessModal = $(this).attr('data-success-modal') || '';
    const dataSuccessRedirect = $(this).attr('data-success-redirect') || '';
    if (dataLocalStorageKey && localStorage.getItem(dataLocalStorageKey) === 'true') {
      // This means its a gated resource card and local storage value is set
      // Booleans are not 100% compatible with local storage.
      // Gated Form was already filled. Dont show it again
      const $this = $(this);
      if (dataSuccessModal) {
        $this.attr('data-target', dataSuccessModal);
      } else if (dataSuccessRedirect) {
        $this.attr('href', dataSuccessRedirect);
        $this.removeAttr('data-toggle')
          .removeAttr('data-target');
      }
      $this.removeAttr('data-local-storage-key')
        .removeAttr('data-success-modal')
        .removeAttr('data-success-redirect');
    }
  });
  setAriaLabel();
  setNormalizedHeightOnResourceBox();
};

const setNormalizedHeightOnResourceBox = () => {
  const $resourceCardSections = $('.casestudy-resource-section').filter(':not(.hide)');
  $resourceCardSections.each(function () {
    const $resourceBoxes = $(this).find('.resource-box');
    const heights = [];
    $resourceBoxes.each(function () {
      heights.push(parseInt($(this).height()));
    });
    const maxHeight = Math.max(...heights);
    $(this).find('.resource-box').height(maxHeight);
  });
};

const setAriaLabel = () => {
  const $resourceCardSections = $('.casestudy-resource-section');
  $resourceCardSections.each(function () {
    const $resourceBoxes = $(this).find('.card-item');
    $resourceBoxes.each(function () {
      let ariaLabel = $(this).attr('aria-label');
      if (!ariaLabel) {
        ariaLabel = $(this).find('.resource-box-right > *:first-child').text();
        $(this).attr('aria-label', ariaLabel);
      }
    });
  });
};

export { resourceCard, setNormalizedHeightOnResourceBox };
